import React, { ReactNode } from 'react';

interface VisiteurLayoutProps {
  children: ReactNode;  // Explicitly define children as a prop
}

const VisiteurLayout: React.FC<VisiteurLayoutProps> = ({ children }) => {
  return <>{children}</>;
};

export default VisiteurLayout;
